import { navigate } from '../lib/router.ts';

/** Shown when phase=running: links to the run view (spec: "Phase banner links to the run view"). */
export function PhaseBanner({ sessionId, runId }: { sessionId: string; runId: string }): JSX.Element {
  return (
    <div className="panel phase-banner">
      <span>A pipeline run is in progress.</span>
      <button className="btn sm" onClick={() => navigate({ view: 'run', sessionId, runId })}>
        Watch progress →
      </button>
    </div>
  );
}
